import { createContext, useContext } from "react";

export type FeedbackFormState = Record<string, unknown>;

export type FeedbackFormContextValue = {
  values: FeedbackFormState;
  setValue: (name: string, value: unknown) => void;
};

export const FeedbackFormContext = createContext<FeedbackFormContextValue | null>(null);

export function useFeedbackForm(): FeedbackFormContextValue {
  const ctx = useContext(FeedbackFormContext);
  if (!ctx) {
    throw new Error("Feedback field components must be used inside <FeedbackForm>");
  }
  return ctx;
}
